import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SuccessPage.css'; // Import the CSS file for styling

const SuccessPage = () => {
    const [documentId, setDocumentId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Retrieve documentId from sessionStorage
        const storedDocumentId = sessionStorage.getItem("documentId");
        if (storedDocumentId) {
            setDocumentId(storedDocumentId);
        }
    }, []);

    const handleClose = () => {
        // Clear the documentId from sessionStorage if you don't need it after navigating away
        sessionStorage.removeItem("documentId");
        navigate('/request-list');
    };

    return (
        <div style={{backgroundColor: '#fff',height: '100%'}}>
        <div className="page-title">
            <p>Signature Page</p>
        </div>
        <div className="success-page" style={{marginTop: '50px'}}>          
            <div className="success-box">
                <div className="checkmark-container">
                    <div className="checkmark-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="checkmark">
                            <path d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                </div>
                <h2>Affidavit Updated Successfully</h2>
            </div>
            <div className="document-info">
                <strong>Document ID:</strong> {documentId ? documentId : 'N/A'} {/* Display the document ID */}
                {/* <button className="close-btn" onClick={handleClose}>Done</button> */}
            </div>
        </div>
        </div>
    );
};

export default SuccessPage;